import { expandRange, isWeekday, isWeekend, monthOf } from './dates';

export interface MonthMask {
  months?: string[];
}

export function applyMask(set: Set<string>, mask: MonthMask = {}): Set<string> {
  if (!mask.months || mask.months.length === 0) return set;
  const allow = new Set(mask.months);
  const out = new Set<string>();
  for (const iso of set) {
    if (allow.has(monthOf(iso))) out.add(iso);
  }
  return out;
}

export function selectAll(start: string, end: string, mask: MonthMask = {}): Set<string> {
  return applyMask(new Set(expandRange(start, end)), mask);
}

export function selectWeekends(start: string, end: string, mask: MonthMask = {}): Set<string> {
  const set = new Set(expandRange(start, end).filter(isWeekend));
  return applyMask(set, mask);
}

export function selectWeekdays(start: string, end: string, mask: MonthMask = {}): Set<string> {
  const set = new Set(expandRange(start, end).filter(isWeekday));
  return applyMask(set, mask);
}

export function selectNone(): Set<string> {
  return new Set();
}
